import { useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
// @mui
import { Checkbox, FormControlLabel,FormGroup, Stack  } from '@mui/material';

import { LoadingButton } from '@mui/lab';
// components
import { login } from '../../../services/api/auth';
import { showSnackbar } from '../../../components/snackbar';
import TextInput from '../../../components/inputs/textInput/textInput';
import { isLoggedIn } from '../../../helpers/auth.helper';
import { translateThis } from '../../../helpers/language.helper';
// ----------------------------------------------------------------------

export default function LoginForm() {
    const navigate = useNavigate();
    const location = useLocation();
    const isAuth = isLoggedIn();
    const { from } = location.state || { from: { pathname: "/my-portal" } };

    if (isAuth) {
        navigate(from, { replace: true });
    }

    const [email, setEmail] = useState('');
    const [isLoading, setIsLoading] = useState(false);
    const [isRememberMeChecked, setIsRememberMeChecked] = useState(false);
    const [password, setPassword] = useState('');
    const [validPassword, setValidPassword] = useState({
        eightCharacter: false,
        containNumber: false,
        containUpperCase: false,
        containSpecialChar: false
    });


    const onSubmit = () => {
        setIsLoading(true);
        login({ email, password }).then((data) => {
            if (data.success) {
                navigate(from, { replace: true });
                showSnackbar().success(data.message)
            } else {
                showSnackbar().failure(data.message)

            }
        }).finally(() => setIsLoading(false))
            ;
    };

    /**
     * To validate password requirement
     * @param {String} password 
     */
    const validatePassword = (password) => {
        const rules = {
            eightCharacter: false,
            containNumber: false,
            containUpperCase: false,
            containSpecialChar: false
        }

        if (password.length > 7) { // To check if password contain 8 chars
            rules.eightCharacter = true;
        }
        if (/\d/.test(password)) { // To check if password contain numbers
            rules.containNumber = true;
        }
        if (password !== password.toLowerCase()) { // To check if password contain uppercase
            rules.containUpperCase = true;
        }
        const format = /[ `!@#$%^&*()_+\-=[\]{};':"\\|,.<>/?~]/;
        if (format.test(password)) { // To check if password contain special chars
            rules.containSpecialChar = true;
        }
        setValidPassword(rules)
        if (rules.containNumber &&
            rules.containSpecialChar &&
            rules.containUpperCase &&
            rules.eightCharacter
        ) {
            setPassword(password)
        } else {
            setPassword('')
        }
    }

    return (
        <>
            {/* <Stack className='google-auth' spacing={3}>
                <Button className='google-auth-btn'> {SVGIcons.GoogleIcon()} Log in with Google </Button>
            </Stack>
            <Stack className='divider' direction="row" alignItems="center" justifyContent="center" sx={{ my: 2 }}>
                <Divider>or</Divider>
            </Stack> */}
            <Stack className='login-form standard-form' spacing={3}>
                <TextInput
                    key={`login-email`}
                    label='Email'
                    name='email'
                    type='email'
                    required
                    placeholder='Please enter your email address'
                    className='custom-textfield'
                    getValue={(_, value) => setEmail(value)}

                />

                <TextInput
                    key={`login-password`}
                    label='Password'
                    name='password'
                    type='password'
                    isRequired={false}
                    placeholder='Please enter your password'
                    className='custom-textfield'
                    getValue={(_, value) => validatePassword(value)}

                />
                <Stack className='password-requirement-points' variant='div' spacing={3} style={{ marginTop: '0' }}>
                    <ul>
                        <li className={validPassword.eightCharacter ? 'checked' : ''}>{translateThis('At least 8 characters long')}</li>
                        <li className={validPassword.containNumber ? 'checked' : ''}>{translateThis('1 number')}</li>
                        <li className={validPassword.containUpperCase ? 'checked' : ''}>{translateThis('1 uppercase character')}</li>
                        <li className={validPassword.containSpecialChar ? 'checked' : ''}>{translateThis('1 special symbol')}</li>
                    </ul>
                </Stack>
                <FormGroup className='custom-checkbox'>
                    <FormControlLabel control={<Checkbox checked={isRememberMeChecked} onChange={(e) => setIsRememberMeChecked(e.target.checked)} />} label={
                        <>Remember me</>
                    } />
                </FormGroup>
                <Stack className='additional-btn' variant='div' spacing={3} style={{ marginTop: '0' }}>
                    <p style={{ textAlign: 'right' }}><Link to={'/auth/forgot-password'} replace>Forgot your password?</Link></p>
                </Stack>
                <LoadingButton
                    loading={isLoading}
                    loadingPosition='start'
                    startIcon={<></>} // To remove Mui warning
                    fullWidth
                    disabled={!email || !password}
                    size="large"
                    type="submit"
                    variant="contained"
                    className='standard-btn'
                    onClick={onSubmit}>
                    Login
                </LoadingButton>

            </Stack>

            <Stack className='additional-btn' variant='div' spacing={3}>
                <p>Don't have an account yet? <Link to={'/auth/register'} >Sign up</Link></p>
            </Stack>
        </>
    );
}
